import React, { useState } from 'react';
import { Button, Checkbox, Group, Modal, Paper, SimpleGrid, Stack } from '@mantine/core';
import { DateInput } from '@mantine/dates';

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Dates are `YYYY-MM-DD` strings, empty when not picked. */
  onApply: (startDate: string, endDate: string, checkboxState: any) => void;
  checkboxProps: { id: string; label: string }[];
  checkboxStates: any;
  setCheckboxStates: (id: any) => void;
}

const FilterModal = ({
  isOpen,
  onClose,
  onApply,
  checkboxProps,
  checkboxStates,
  setCheckboxStates,
}: FilterModalProps) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  return (
    <Modal opened={isOpen} onClose={onClose} title="Filter by Date" size="sm">
      <Stack gap="md">
        <SimpleGrid cols={2}>
          <DateInput
            label="Start Date"
            placeholder="Pick a date"
            valueFormat="DD-MM-YYYY"
            value={startDate || null}
            onChange={(value) => setStartDate(value || '')}
            clearable
          />
          <DateInput
            label="End Date"
            placeholder="Pick a date"
            valueFormat="DD-MM-YYYY"
            value={endDate || null}
            onChange={(value) => setEndDate(value || '')}
            clearable
          />
        </SimpleGrid>

        <Stack gap="xs">
          {checkboxProps.map((checkbox) => (
            <Paper key={checkbox.id} withBorder p="sm" radius="md">
              <Checkbox
                label={checkbox.label}
                checked={checkboxStates === checkbox.id}
                onChange={() => setCheckboxStates(checkbox.id)}
              />
            </Paper>
          ))}
        </Stack>

        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => onApply(startDate, endDate, checkboxStates)}>
            Apply
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default FilterModal;
